const tagDataList = {
  main: {
    shareTitle: 'SBS TV : 보고 싶은 프로그램을 찾기 쉽게!',
    shareDescription:
      '로맨스, 버라이어티, 시사토크, 다큐멘터리 등 다양한 콘텐츠들 속에서 내 취향에 맞는 TV프로그램을 추천해드립니다.',
    shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/2025/sbs_tv.png',
    currentUrl: 'https://www.sbs.co.kr/tv',
    keywords:
      'SBS TV,sbs 방송,sbs 프로그램,sbs 드라마,sbs 예능,sbs 교양,sbs 시사,sbs 다큐,sbs 다큐멘터리,sbs 스포츠,sbs drama,sbs entertainment,sbs dacu,sbs 무료보기,sbs 다시보기,sbs 인기 드라마,sbs 인기 예능,sbs인기 교양',
  },
  drama: {
    shareTitle: 'SBS 드라마 : 600여개 레전드·최신작품을 한번에!',
    shareDescription:
      '최신드라마는 물론 30년간 방영한 레전드 드라마까지, 가장 빠르고 정확한 드라마 정보를 즐기세요!',
    shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/2025/sbs_tv.png',
    currentUrl: 'https://www.sbs.co.kr/tv/drama',
    keywords:
      'sbs드라마,sbs드라마 다시보기,sbs드라마 무료보기,sbs드라마 추천,sbs드라마 보기,sbs 인기 드라마,드라마 무료보기,무료드라마,한국드라마 다시보기,korean drama free,kdrama 다시보기,korean drama streaming,한국드라마 무료보기',
  },
  enter: {
    shareTitle: 'SBS 예능 : 웃음과 감동이 공존하는 힐링 예능',
    shareDescription:
      '먹방, 리얼버라이어티, 관찰 예능, 토크쇼 등 다양한 장르들의 SBS 예능 프로그램들을 가장 빠르게 만나보세요!',
    shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/2025/sbs_tv.png',
    currentUrl: 'https://www.sbs.co.kr/tv/enter',
    keywords:
      'sbs예능,sbs예능 무료보기,sbs예능 무료다시보기,sbs인기예능,sbs예능 다시보기,sbs 예능 프로그램,sbs 옛날 예능,sbs 무료다시보기,sbs 역대예능,sbs 90년대 예능,sbs 옛날tv,예능다시보기,예능 무료 다시보기,한국예능 다시보기',
  },
  culture: {
    shareTitle: 'SBS 교양 : 정확한 시사정보·생생한 생활정보',
    shareDescription:
      '가장 정확하고 심층깊은 시사정보는 물론 건강, 인테리어 등 다양하고 생생한 생활밀착형 정보를 제공합니다',
    shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/2025/sbs_tv.png',
    currentUrl: 'https://www.sbs.co.kr/tv/culture',
    keywords:
      'sbs교양,sbs교양 다시보기,sbs교양 무료보기,그것이알고싶다 다시보기,그것이알고싶다 재방송,그것이알고싶다 무료보기,그알 무료보기,그알 재방송,sbs스페셜 다시보기,sbs스페셜 재방송,sbs스페셜 무료보기,동물농장 다시보기,동물농장 재방송,생활의달인 다시보기,생활의달인 재방송,생활의달인 무료보기,sbs시사교양,에스비에스 교양,sbs시사 프로그램,sbs교양 프로그램,sbs교양 홈페이지',
  },
  sports: {
    shareTitle: 'SBS 스포츠',
    shareDescription: '야구, 축구, 골프 및 종합 스포츠',
    shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/2025/sbs_tv.png',
    currentUrl: 'https://www.sbs.co.kr/tv/sports',
    keywords: 'SBS 야구,SBS 축구,SBS 스포츠,월드컵,동계 올림픽,올림픽',
  },
  free: {
    shareTitle: 'SBS 무료 다시보기 : 8만 여편의 VOD가 무료!',
    shareDescription:
      'SBS VOD 8만여편 모두! 1990년대부터 최근까지 SBS에서 30년간 방영된 프로그램을 지금 무료로 즐기세요',
    shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/2025/sbs_tv.png',
    currentUrl: 'https://www.sbs.co.kr/tv/free',
    keywords:
      'sbs,sbs all vod,sbs vod 무료보기,sbs 다시보기 무료,sbs 드라마 다시보기,sbs vod 다시보기 무료,한국 드라마 무료보기,korean drama free,sbs vod free,종영드라마 무료보기,SBS 레전드 프로그램,SBS 레전드 예능',
  },
};

export default function index(pageSection, pageCategory = '') {
  const defaultSectionKey = 'main';
  pageSection = pageSection || defaultSectionKey;

  let result = tagDataList[pageSection];

  if (!result) {
    result = tagDataList[defaultSectionKey];
  }

  return { ...result };
}
